"use strict";

var _ = require('lodash');

var PropTypes = require('prop-types');

var React = require('react');

var getValueLinkProps = function getValueLinkProps(props) {
  return _.has(props, 'valueLink') ? {
    value: props.valueLink.value,
    onChange: props.valueLink.requestChange
  } : {};
};

var createWithUtils = function createWithUtils(innerComp) {
  return function (props) {
    var getClassName = function getClassName(defaultClassName) {
      var propName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'className';
      return [defaultClassName, props[propName]].join(' ');
    };

    var valueLinkProps = getValueLinkProps(props);
    var dataHook = props.dataHook || props.automationId;
    var dataHooks = dataHook ? {
      dataHook: dataHook
    } : {};

    var newProps = _({}).assign(props, dataHooks, {
      getClassName: getClassName
    }, valueLinkProps).omit(['valueLink']).value();

    return React.createElement(innerComp, newProps);
  };
};

createWithUtils.propTypes = {
  /**
   * string identifier for tests
   * @deprecated please use `dataHook` prop instead
   */
  automationId: PropTypes.string,

  /** string identifier for tests */
  dataHook: PropTypes.string
};
createWithUtils.defaultProps = {
  automationId: null,
  dataHook: ''
};
module.exports = createWithUtils;